// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AiSocietyRouteImport } from './routes/ai-society'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as ArsivRouteImport } from './routes/arsiv'
import { Route as BaslangicRouteImport } from './routes/baslangic'
import { Route as BookRouteImport } from './routes/book'
import { Route as BooksRouteImport } from './routes/books'
import { Route as ClimateSystemsRouteImport } from './routes/climate-systems'
import { Route as Cop31RouteImport } from './routes/cop31'
import { Route as Cop31GuideRouteImport } from './routes/cop31-guide'
import { Route as Cop31HaberArsiviRouteImport } from './routes/cop31-haber-arsivi'
import { Route as Cop31NewsArchiveRouteImport } from './routes/cop31-news-archive'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as HakkimdaRouteImport } from './routes/hakkimda'
import { Route as HesabimRouteImport } from './routes/hesabim'
import { Route as HumanFuturesRouteImport } from './routes/human-futures'
import { Route as IklimSistemleriRouteImport } from './routes/iklim-sistemleri'
import { Route as InsanVeGelecekRouteImport } from './routes/insan-ve-gelecek'
import { Route as KitaplarRouteImport } from './routes/kitaplar'
import { Route as KonusmalarRouteImport } from './routes/konusmalar'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as PodcastRouteImport } from './routes/podcast'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RaporlarRouteImport } from './routes/raporlar'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SozlukRouteImport } from './routes/sozluk'
import { Route as SurdurulebilirlikRouteImport } from './routes/surdurulebilirlik'
import { Route as SustainabilityCritiqueRouteImport } from './routes/sustainability-critique'
import { Route as YapayZekaToplumRouteImport } from './routes/yapay-zeka-toplum'
import { Route as YazarRouteImport } from './routes/yazar'
import { Route as YonetimOnizlemeRouteImport } from './routes/yonetim-onizleme'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminIdRouteImport } from './routes/admin.$id'
import { Route as AdminAiHealthRouteImport } from './routes/admin.ai-health'
import { Route as AdminAiToolsRouteImport } from './routes/admin.ai-tools'
import { Route as AdminAiTrafficRouteImport } from './routes/admin.ai-traffic'
import { Route as AdminCarouselRouteImport } from './routes/admin.carousel'
import { Route as AdminConceptEmbedRouteImport } from './routes/admin.concept-embed'
import { Route as AdminContentRouteImport } from './routes/admin.content'
import { Route as AdminErisimDenetimiRouteImport } from './routes/admin.erisim-denetimi'
import { Route as AdminHomeRouteImport } from './routes/admin.home'
import { Route as AdminIcerikRouteImport } from './routes/admin.icerik'
import { Route as AdminKaynaklarRouteImport } from './routes/admin.kaynaklar'
import { Route as AdminMagazineRouteImport } from './routes/admin.magazine'
import { Route as AdminMigrateImagesRouteImport } from './routes/admin.migrate-images'
import { Route as AdminNewRouteImport } from './routes/admin.new'
import { Route as AdminNewsletterRouteImport } from './routes/admin.newsletter'
import { Route as AdminNewsletterEnRouteImport } from './routes/admin.newsletter-en'
import { Route as AdminNewsletterPerformanceRouteImport } from './routes/admin.newsletter-performance'
import { Route as AdminPerformanceRouteImport } from './routes/admin.performance'
import { Route as AdminReportLinksRouteImport } from './routes/admin.report-links'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminSearchConsoleRouteImport } from './routes/admin.search-console'
import { Route as AdminStarterRouteImport } from './routes/admin.starter'
import { Route as AdminTemalarRouteImport } from './routes/admin.temalar'
import { Route as AdminUyelerRouteImport } from './routes/admin.uyeler'
import { Route as AdminYazilarRouteImport } from './routes/admin.yazilar'
import { Route as BultenIndexRouteImport } from './routes/bulten.index'
import { Route as BultenSlugRouteImport } from './routes/bulten.$slug'
import { Route as ConceptsIndexRouteImport } from './routes/concepts.index'
import { Route as ConceptsSlugRouteImport } from './routes/concepts.$slug'
import { Route as DergiIndexRouteImport } from './routes/dergi.index'
import { Route as DergiSlugRouteImport } from './routes/dergi.$slug'
import { Route as EssaysSlugRouteImport } from './routes/essays.$slug'
import { Route as EtiketIndexRouteImport } from './routes/etiket.index'
import { Route as EtiketSlugRouteImport } from './routes/etiket.$slug'
import { Route as FrameworksIndexRouteImport } from './routes/frameworks.index'
import { Route as FrameworksSlugRouteImport } from './routes/frameworks.$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySplatRouteImport } from './routes/glossary.$'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as IdeasIndexRouteImport } from './routes/ideas.index'
import { Route as IdeasSlugRouteImport } from './routes/ideas.$slug'
import { Route as KitaplarIndexRouteImport } from './routes/kitaplar.index'
import { Route as KitaplarHayatiYasanirKilanBoslukturRouteImport } from './routes/kitaplar.hayati-yasanir-kilan-bosluktur'
import { Route as KitaplarIklimDegilInsanlikKriziRouteImport } from './routes/kitaplar.iklim-degil-insanlik-krizi'
import { Route as KitaplarYalnizlikAsRouteImport } from './routes/kitaplar.yalnizlik-as'
import { Route as KitaplarYapayZekaGucunIkiYuzuRouteImport } from './routes/kitaplar.yapay-zeka-gucun-iki-yuzu'
import { Route as KonusmalarIdRouteImport } from './routes/konusmalar_.$id'
import { Route as RaporlarIndexRouteImport } from './routes/raporlar.index'
import { Route as RaporlarSlugRouteImport } from './routes/raporlar.$slug'
import { Route as ResearchIndexRouteImport } from './routes/research.index'
import { Route as ResearchSlugRouteImport } from './routes/research.$slug'
import { Route as SozlukIndexRouteImport } from './routes/sozluk.index'
import { Route as SozlukSplatRouteImport } from './routes/sozluk.$'
import { Route as SozlukSlugRouteImport } from './routes/sozluk.$slug'
import { Route as TemaSlugRouteImport } from './routes/tema.$slug'
import { Route as TopicsIndexRouteImport } from './routes/topics.index'
import { Route as TopicsSlugRouteImport } from './routes/topics.$slug'
import { Route as YazilarIndexRouteImport } from './routes/yazilar.index'
import { Route as YazilarSlugRouteImport } from './routes/yazilar.$slug'
import { Route as YazilarGreenwashingNedirRouteImport } from './routes/yazilar.greenwashing-nedir'
import { Route as YazilarSdgRehberiRouteImport } from './routes/yazilar.sdg-rehberi'
import { Route as YazilarSurdurulebilirKalkinmaNedirRouteImport } from './routes/yazilar.surdurulebilir-kalkinma-nedir'
import { Route as YazilarSurdurulebilirlikNedirRehberiRouteImport } from './routes/yazilar.surdurulebilirlik-nedir-rehberi'
import { Route as YazilarYesilMutabakatRehberiRouteImport } from './routes/yazilar.yesil-mutabakat-rehberi'
import { Route as AdminBultenIndexRouteImport } from './routes/admin.bulten.index'
import { Route as AdminBultenIdRouteImport } from './routes/admin.bulten.$id'
import { Route as AdminYaziIdRouteImport } from './routes/admin.yazi.$id'
import { Route as AdminYaziYeniRouteImport } from './routes/admin.yazi.yeni'
import { Route as Cop31GuideNotesSlugRouteImport } from './routes/cop31-guide_.notes.$slug'
import { Route as Cop31NotlarSlugRouteImport } from './routes/cop31_.notlar.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AiSocietyRoute = AiSocietyRouteImport.update({
            id: '/ai-society',path: '/ai-society',getParentRoute: () => rootRouteImport
          })
const ArchiveRoute = ArchiveRouteImport.update({
            id: '/archive',path: '/archive',getParentRoute: () => rootRouteImport
          })
const ArsivRoute = ArsivRouteImport.update({
            id: '/arsiv',path: '/arsiv',getParentRoute: () => rootRouteImport
          })
const BaslangicRoute = BaslangicRouteImport.update({
            id: '/baslangic',path: '/baslangic',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const BooksRoute = BooksRouteImport.update({
            id: '/books',path: '/books',getParentRoute: () => rootRouteImport
          })
const ClimateSystemsRoute = ClimateSystemsRouteImport.update({
            id: '/climate-systems',path: '/climate-systems',getParentRoute: () => rootRouteImport
          })
const Cop31Route = Cop31RouteImport.update({
            id: '/cop31',path: '/cop31',getParentRoute: () => rootRouteImport
          })
const Cop31GuideRoute = Cop31GuideRouteImport.update({
            id: '/cop31-guide',path: '/cop31-guide',getParentRoute: () => rootRouteImport
          })
const Cop31HaberArsiviRoute = Cop31HaberArsiviRouteImport.update({
            id: '/cop31-haber-arsivi',path: '/cop31-haber-arsivi',getParentRoute: () => rootRouteImport
          })
const Cop31NewsArchiveRoute = Cop31NewsArchiveRouteImport.update({
            id: '/cop31-news-archive',path: '/cop31-news-archive',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const HakkimdaRoute = HakkimdaRouteImport.update({
            id: '/hakkimda',path: '/hakkimda',getParentRoute: () => rootRouteImport
          })
const HesabimRoute = HesabimRouteImport.update({
            id: '/hesabim',path: '/hesabim',getParentRoute: () => rootRouteImport
          })
const HumanFuturesRoute = HumanFuturesRouteImport.update({
            id: '/human-futures',path: '/human-futures',getParentRoute: () => rootRouteImport
          })
const IklimSistemleriRoute = IklimSistemleriRouteImport.update({
            id: '/iklim-sistemleri',path: '/iklim-sistemleri',getParentRoute: () => rootRouteImport
          })
const InsanVeGelecekRoute = InsanVeGelecekRouteImport.update({
            id: '/insan-ve-gelecek',path: '/insan-ve-gelecek',getParentRoute: () => rootRouteImport
          })
const KitaplarRoute = KitaplarRouteImport.update({
            id: '/kitaplar',path: '/kitaplar',getParentRoute: () => rootRouteImport
          })
const KonusmalarRoute = KonusmalarRouteImport.update({
            id: '/konusmalar',path: '/konusmalar',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const PodcastRoute = PodcastRouteImport.update({
            id: '/podcast',path: '/podcast',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RaporlarRoute = RaporlarRouteImport.update({
            id: '/raporlar',path: '/raporlar',getParentRoute: () => rootRouteImport
          })
const ReportsRoute = ReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SozlukRoute = SozlukRouteImport.update({
            id: '/sozluk',path: '/sozluk',getParentRoute: () => rootRouteImport
          })
const SurdurulebilirlikRoute = SurdurulebilirlikRouteImport.update({
            id: '/surdurulebilirlik',path: '/surdurulebilirlik',getParentRoute: () => rootRouteImport
          })
const SustainabilityCritiqueRoute = SustainabilityCritiqueRouteImport.update({
            id: '/sustainability-critique',path: '/sustainability-critique',getParentRoute: () => rootRouteImport
          })
const YapayZekaToplumRoute = YapayZekaToplumRouteImport.update({
            id: '/yapay-zeka-toplum',path: '/yapay-zeka-toplum',getParentRoute: () => rootRouteImport
          })
const YazarRoute = YazarRouteImport.update({
            id: '/yazar',path: '/yazar',getParentRoute: () => rootRouteImport
          })
const YonetimOnizlemeRoute = YonetimOnizlemeRouteImport.update({
            id: '/yonetim-onizleme',path: '/yonetim-onizleme',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminIdRoute = AdminIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminRoute
          })
const AdminAiHealthRoute = AdminAiHealthRouteImport.update({
            id: '/ai-health',path: '/ai-health',getParentRoute: () => AdminRoute
          })
const AdminAiToolsRoute = AdminAiToolsRouteImport.update({
            id: '/ai-tools',path: '/ai-tools',getParentRoute: () => AdminRoute
          })
const AdminAiTrafficRoute = AdminAiTrafficRouteImport.update({
            id: '/ai-traffic',path: '/ai-traffic',getParentRoute: () => AdminRoute
          })
const AdminCarouselRoute = AdminCarouselRouteImport.update({
            id: '/carousel',path: '/carousel',getParentRoute: () => AdminRoute
          })
const AdminConceptEmbedRoute = AdminConceptEmbedRouteImport.update({
            id: '/concept-embed',path: '/concept-embed',getParentRoute: () => AdminRoute
          })
const AdminContentRoute = AdminContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AdminRoute
          })
const AdminErisimDenetimiRoute = AdminErisimDenetimiRouteImport.update({
            id: '/erisim-denetimi',path: '/erisim-denetimi',getParentRoute: () => AdminRoute
          })
const AdminHomeRoute = AdminHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AdminRoute
          })
const AdminIcerikRoute = AdminIcerikRouteImport.update({
            id: '/icerik',path: '/icerik',getParentRoute: () => AdminRoute
          })
const AdminKaynaklarRoute = AdminKaynaklarRouteImport.update({
            id: '/kaynaklar',path: '/kaynaklar',getParentRoute: () => AdminRoute
          })
const AdminMagazineRoute = AdminMagazineRouteImport.update({
            id: '/magazine',path: '/magazine',getParentRoute: () => AdminRoute
          })
const AdminMigrateImagesRoute = AdminMigrateImagesRouteImport.update({
            id: '/migrate-images',path: '/migrate-images',getParentRoute: () => AdminRoute
          })
const AdminNewRoute = AdminNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminRoute
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => AdminRoute
          })
const AdminNewsletterEnRoute = AdminNewsletterEnRouteImport.update({
            id: '/newsletter-en',path: '/newsletter-en',getParentRoute: () => AdminRoute
          })
const AdminNewsletterPerformanceRoute = AdminNewsletterPerformanceRouteImport.update({
            id: '/newsletter-performance',path: '/newsletter-performance',getParentRoute: () => AdminRoute
          })
const AdminPerformanceRoute = AdminPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => AdminRoute
          })
const AdminReportLinksRoute = AdminReportLinksRouteImport.update({
            id: '/report-links',path: '/report-links',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminSearchConsoleRoute = AdminSearchConsoleRouteImport.update({
            id: '/search-console',path: '/search-console',getParentRoute: () => AdminRoute
          })
const AdminStarterRoute = AdminStarterRouteImport.update({
            id: '/starter',path: '/starter',getParentRoute: () => AdminRoute
          })
const AdminTemalarRoute = AdminTemalarRouteImport.update({
            id: '/temalar',path: '/temalar',getParentRoute: () => AdminRoute
          })
const AdminUyelerRoute = AdminUyelerRouteImport.update({
            id: '/uyeler',path: '/uyeler',getParentRoute: () => AdminRoute
          })
const AdminYazilarRoute = AdminYazilarRouteImport.update({
            id: '/yazilar',path: '/yazilar',getParentRoute: () => AdminRoute
          })
const BultenIndexRoute = BultenIndexRouteImport.update({
            id: '/bulten/',path: '/bulten/',getParentRoute: () => rootRouteImport
          })
const BultenSlugRoute = BultenSlugRouteImport.update({
            id: '/bulten/$slug',path: '/bulten/$slug',getParentRoute: () => rootRouteImport
          })
const ConceptsIndexRoute = ConceptsIndexRouteImport.update({
            id: '/concepts/',path: '/concepts/',getParentRoute: () => rootRouteImport
          })
const ConceptsSlugRoute = ConceptsSlugRouteImport.update({
            id: '/concepts/$slug',path: '/concepts/$slug',getParentRoute: () => rootRouteImport
          })
const DergiIndexRoute = DergiIndexRouteImport.update({
            id: '/dergi/',path: '/dergi/',getParentRoute: () => rootRouteImport
          })
const DergiSlugRoute = DergiSlugRouteImport.update({
            id: '/dergi/$slug',path: '/dergi/$slug',getParentRoute: () => rootRouteImport
          })
const EssaysSlugRoute = EssaysSlugRouteImport.update({
            id: '/essays/$slug',path: '/essays/$slug',getParentRoute: () => rootRouteImport
          })
const EtiketIndexRoute = EtiketIndexRouteImport.update({
            id: '/etiket/',path: '/etiket/',getParentRoute: () => rootRouteImport
          })
const EtiketSlugRoute = EtiketSlugRouteImport.update({
            id: '/etiket/$slug',path: '/etiket/$slug',getParentRoute: () => rootRouteImport
          })
const FrameworksIndexRoute = FrameworksIndexRouteImport.update({
            id: '/frameworks/',path: '/frameworks/',getParentRoute: () => rootRouteImport
          })
const FrameworksSlugRoute = FrameworksSlugRouteImport.update({
            id: '/frameworks/$slug',path: '/frameworks/$slug',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GlossaryRoute
          })
const GlossarySplatRoute = GlossarySplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => GlossaryRoute
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GlossaryRoute
          })
const IdeasIndexRoute = IdeasIndexRouteImport.update({
            id: '/ideas/',path: '/ideas/',getParentRoute: () => rootRouteImport
          })
const IdeasSlugRoute = IdeasSlugRouteImport.update({
            id: '/ideas/$slug',path: '/ideas/$slug',getParentRoute: () => rootRouteImport
          })
const KitaplarIndexRoute = KitaplarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KitaplarRoute
          })
const KitaplarHayatiYasanirKilanBoslukturRoute = KitaplarHayatiYasanirKilanBoslukturRouteImport.update({
            id: '/hayati-yasanir-kilan-bosluktur',path: '/hayati-yasanir-kilan-bosluktur',getParentRoute: () => KitaplarRoute
          })
const KitaplarIklimDegilInsanlikKriziRoute = KitaplarIklimDegilInsanlikKriziRouteImport.update({
            id: '/iklim-degil-insanlik-krizi',path: '/iklim-degil-insanlik-krizi',getParentRoute: () => KitaplarRoute
          })
const KitaplarYalnizlikAsRoute = KitaplarYalnizlikAsRouteImport.update({
            id: '/yalnizlik-as',path: '/yalnizlik-as',getParentRoute: () => KitaplarRoute
          })
const KitaplarYapayZekaGucunIkiYuzuRoute = KitaplarYapayZekaGucunIkiYuzuRouteImport.update({
            id: '/yapay-zeka-gucun-iki-yuzu',path: '/yapay-zeka-gucun-iki-yuzu',getParentRoute: () => KitaplarRoute
          })
const KonusmalarIdRoute = KonusmalarIdRouteImport.update({
            id: '/konusmalar_/$id',path: '/konusmalar/$id',getParentRoute: () => rootRouteImport
          })
const RaporlarIndexRoute = RaporlarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RaporlarRoute
          })
const RaporlarSlugRoute = RaporlarSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => RaporlarRoute
          })
const ResearchIndexRoute = ResearchIndexRouteImport.update({
            id: '/research/',path: '/research/',getParentRoute: () => rootRouteImport
          })
const ResearchSlugRoute = ResearchSlugRouteImport.update({
            id: '/research/$slug',path: '/research/$slug',getParentRoute: () => rootRouteImport
          })
const SozlukIndexRoute = SozlukIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SozlukRoute
          })
const SozlukSplatRoute = SozlukSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SozlukRoute
          })
const SozlukSlugRoute = SozlukSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SozlukRoute
          })
const TemaSlugRoute = TemaSlugRouteImport.update({
            id: '/tema/$slug',path: '/tema/$slug',getParentRoute: () => rootRouteImport
          })
const TopicsIndexRoute = TopicsIndexRouteImport.update({
            id: '/topics/',path: '/topics/',getParentRoute: () => rootRouteImport
          })
const TopicsSlugRoute = TopicsSlugRouteImport.update({
            id: '/topics/$slug',path: '/topics/$slug',getParentRoute: () => rootRouteImport
          })
const YazilarIndexRoute = YazilarIndexRouteImport.update({
            id: '/yazilar/',path: '/yazilar/',getParentRoute: () => rootRouteImport
          })
const YazilarSlugRoute = YazilarSlugRouteImport.update({
            id: '/yazilar/$slug',path: '/yazilar/$slug',getParentRoute: () => rootRouteImport
          })
const YazilarGreenwashingNedirRoute = YazilarGreenwashingNedirRouteImport.update({
            id: '/yazilar/greenwashing-nedir',path: '/yazilar/greenwashing-nedir',getParentRoute: () => rootRouteImport
          })
const YazilarSdgRehberiRoute = YazilarSdgRehberiRouteImport.update({
            id: '/yazilar/sdg-rehberi',path: '/yazilar/sdg-rehberi',getParentRoute: () => rootRouteImport
          })
const YazilarSurdurulebilirKalkinmaNedirRoute = YazilarSurdurulebilirKalkinmaNedirRouteImport.update({
            id: '/yazilar/surdurulebilir-kalkinma-nedir',path: '/yazilar/surdurulebilir-kalkinma-nedir',getParentRoute: () => rootRouteImport
          })
const YazilarSurdurulebilirlikNedirRehberiRoute = YazilarSurdurulebilirlikNedirRehberiRouteImport.update({
            id: '/yazilar/surdurulebilirlik-nedir-rehberi',path: '/yazilar/surdurulebilirlik-nedir-rehberi',getParentRoute: () => rootRouteImport
          })
const YazilarYesilMutabakatRehberiRoute = YazilarYesilMutabakatRehberiRouteImport.update({
            id: '/yazilar/yesil-mutabakat-rehberi',path: '/yazilar/yesil-mutabakat-rehberi',getParentRoute: () => rootRouteImport
          })
const AdminBultenIndexRoute = AdminBultenIndexRouteImport.update({
            id: '/bulten/',path: '/bulten/',getParentRoute: () => AdminRoute
          })
const AdminBultenIdRoute = AdminBultenIdRouteImport.update({
            id: '/bulten/$id',path: '/bulten/$id',getParentRoute: () => AdminRoute
          })
const AdminYaziIdRoute = AdminYaziIdRouteImport.update({
            id: '/yazi/$id',path: '/yazi/$id',getParentRoute: () => AdminRoute
          })
const AdminYaziYeniRoute = AdminYaziYeniRouteImport.update({
            id: '/yazi/yeni',path: '/yazi/yeni',getParentRoute: () => AdminRoute
          })
const Cop31GuideNotesSlugRoute = Cop31GuideNotesSlugRouteImport.update({
            id: '/cop31-guide_/notes/$slug',path: '/cop31-guide/notes/$slug',getParentRoute: () => rootRouteImport
          })
const Cop31NotlarSlugRoute = Cop31NotlarSlugRouteImport.update({
            id: '/cop31_/notlar/$slug',path: '/cop31/notlar/$slug',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminIdRoute: AdminIdRoute,AdminAiHealthRoute: AdminAiHealthRoute,AdminAiToolsRoute: AdminAiToolsRoute,AdminAiTrafficRoute: AdminAiTrafficRoute,AdminCarouselRoute: AdminCarouselRoute,AdminConceptEmbedRoute: AdminConceptEmbedRoute,AdminContentRoute: AdminContentRoute,AdminErisimDenetimiRoute: AdminErisimDenetimiRoute,AdminHomeRoute: AdminHomeRoute,AdminIcerikRoute: AdminIcerikRoute,AdminKaynaklarRoute: AdminKaynaklarRoute,AdminMagazineRoute: AdminMagazineRoute,AdminMigrateImagesRoute: AdminMigrateImagesRoute,AdminNewRoute: AdminNewRoute,AdminNewsletterRoute: AdminNewsletterRoute,AdminNewsletterEnRoute: AdminNewsletterEnRoute,AdminNewsletterPerformanceRoute: AdminNewsletterPerformanceRoute,AdminPerformanceRoute: AdminPerformanceRoute,AdminReportLinksRoute: AdminReportLinksRoute,AdminReportsRoute: AdminReportsRoute,AdminSearchConsoleRoute: AdminSearchConsoleRoute,AdminStarterRoute: AdminStarterRoute,AdminTemalarRoute: AdminTemalarRoute,AdminUyelerRoute: AdminUyelerRoute,AdminYazilarRoute: AdminYazilarRoute,AdminIndexRoute: AdminIndexRoute,AdminBultenIdRoute: AdminBultenIdRoute,AdminYaziIdRoute: AdminYaziIdRoute,AdminYaziYeniRoute: AdminYaziYeniRoute,AdminBultenIndexRoute: AdminBultenIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const GlossaryRouteChildren = {
  GlossarySplatRoute: GlossarySplatRoute,GlossarySlugRoute: GlossarySlugRoute,GlossaryIndexRoute: GlossaryIndexRoute
}

const GlossaryRouteWithChildren = GlossaryRoute._addFileChildren(GlossaryRouteChildren)




const KitaplarRouteChildren = {
  KitaplarHayatiYasanirKilanBoslukturRoute: KitaplarHayatiYasanirKilanBoslukturRoute,KitaplarIklimDegilInsanlikKriziRoute: KitaplarIklimDegilInsanlikKriziRoute,KitaplarYalnizlikAsRoute: KitaplarYalnizlikAsRoute,KitaplarYapayZekaGucunIkiYuzuRoute: KitaplarYapayZekaGucunIkiYuzuRoute,KitaplarIndexRoute: KitaplarIndexRoute
}

const KitaplarRouteWithChildren = KitaplarRoute._addFileChildren(KitaplarRouteChildren)




const RaporlarRouteChildren = {
  RaporlarSlugRoute: RaporlarSlugRoute,RaporlarIndexRoute: RaporlarIndexRoute
}

const RaporlarRouteWithChildren = RaporlarRoute._addFileChildren(RaporlarRouteChildren)




const SozlukRouteChildren = {
  SozlukSplatRoute: SozlukSplatRoute,SozlukSlugRoute: SozlukSlugRoute,SozlukIndexRoute: SozlukIndexRoute
}

const SozlukRouteWithChildren = SozlukRoute._addFileChildren(SozlukRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,AiSocietyRoute: AiSocietyRoute,ArchiveRoute: ArchiveRoute,ArsivRoute: ArsivRoute,BaslangicRoute: BaslangicRoute,BookRoute: BookRoute,BooksRoute: BooksRoute,ClimateSystemsRoute: ClimateSystemsRoute,Cop31Route: Cop31Route,Cop31GuideRoute: Cop31GuideRoute,Cop31HaberArsiviRoute: Cop31HaberArsiviRoute,Cop31NewsArchiveRoute: Cop31NewsArchiveRoute,GlossaryRoute: GlossaryRouteWithChildren,HakkimdaRoute: HakkimdaRoute,HesabimRoute: HesabimRoute,HumanFuturesRoute: HumanFuturesRoute,IklimSistemleriRoute: IklimSistemleriRoute,InsanVeGelecekRoute: InsanVeGelecekRoute,KitaplarRoute: KitaplarRouteWithChildren,KonusmalarRoute: KonusmalarRoute,LoginRoute: LoginRoute,NewsletterRoute: NewsletterRoute,PodcastRoute: PodcastRoute,PrivacyRoute: PrivacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RaporlarRoute: RaporlarRouteWithChildren,ReportsRoute: ReportsRoute,SearchRoute: SearchRoute,SozlukRoute: SozlukRouteWithChildren,SurdurulebilirlikRoute: SurdurulebilirlikRoute,SustainabilityCritiqueRoute: SustainabilityCritiqueRoute,YapayZekaToplumRoute: YapayZekaToplumRoute,YazarRoute: YazarRoute,YonetimOnizlemeRoute: YonetimOnizlemeRoute,BultenSlugRoute: BultenSlugRoute,ConceptsSlugRoute: ConceptsSlugRoute,DergiSlugRoute: DergiSlugRoute,EssaysSlugRoute: EssaysSlugRoute,EtiketSlugRoute: EtiketSlugRoute,FrameworksSlugRoute: FrameworksSlugRoute,IdeasSlugRoute: IdeasSlugRoute,KonusmalarIdRoute: KonusmalarIdRoute,ResearchSlugRoute: ResearchSlugRoute,TemaSlugRoute: TemaSlugRoute,TopicsSlugRoute: TopicsSlugRoute,YazilarSlugRoute: YazilarSlugRoute,YazilarGreenwashingNedirRoute: YazilarGreenwashingNedirRoute,YazilarSdgRehberiRoute: YazilarSdgRehberiRoute,YazilarSurdurulebilirKalkinmaNedirRoute: YazilarSurdurulebilirKalkinmaNedirRoute,YazilarSurdurulebilirlikNedirRehberiRoute: YazilarSurdurulebilirlikNedirRehberiRoute,YazilarYesilMutabakatRehberiRoute: YazilarYesilMutabakatRehberiRoute,BultenIndexRoute: BultenIndexRoute,ConceptsIndexRoute: ConceptsIndexRoute,DergiIndexRoute: DergiIndexRoute,EtiketIndexRoute: EtiketIndexRoute,FrameworksIndexRoute: FrameworksIndexRoute,IdeasIndexRoute: IdeasIndexRoute,ResearchIndexRoute: ResearchIndexRoute,TopicsIndexRoute: TopicsIndexRoute,YazilarIndexRoute: YazilarIndexRoute,Cop31GuideNotesSlugRoute: Cop31GuideNotesSlugRoute,Cop31NotlarSlugRoute: Cop31NotlarSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)